import React, { use, useEffect, useState } from 'react';
import database from '../config/FirbaseConfig';
import '../styles/BestMenu.css';
import '../styles/FeedbackForm.css';
import { useParams, useSearchParams } from "react-router-dom";
import cals from '../assets/icons/0 Calories.svg';
import Labels from '../components/Labels';
import Modal from "react-modal";
import notify from "../assets/audio/orderPlaced.mp3";
import { useNavigate } from 'react-router-dom';


const MenuDrops = ({ restaurantID, RestaurantDetails, menuObj, LabelsData, DietaryFilters, Dietary, setDietary, AddOns, cart, setCart, Ordering, Messages, NavigationSuggestions }) => {
    const [searchParams] = useSearchParams();
    const [Data, setData] = useState(null);
    const [expandedItem, setExpandedItem] = useState(null);
    const [expandedDetails, setExpandedDetails] = useState(true);
    const [itemFeedback, setItemFeedback] = useState(() => {
        return JSON.parse(localStorage.getItem(`${restaurantID}_itemFeedback`) || "{}");
    });
    const navigate = useNavigate();
    const Items = menuObj?.filter(
        (menuObjItems) =>
            menuObjItems?.Name === expandedItem?.Name &&
            menuObjItems.Price !== 0 &&
            menuObjItems.Price !== null &&
            menuObjItems.Price !== "" &&
            menuObjItems.Visible === true &&
            menuObjItems.Visible !== false
    );
    const [selectedValue, setSelectedValue] = useState("");
    const [selectedAddOns, setSelectedAddOns] = useState({});
    const [AdditionalNotes, setAdditionalNotes] = useState(null);
    const [openedSection, setOpenedSection] = useState(null);
    const [count, setCount] = useState(0);
    const audio = new Audio(notify);
    const [favourits, setFavourits] = useState([]);
    const phoneNumber = '9324291794';
    const loading = false;

    const user = JSON.parse(localStorage.getItem(`${restaurantID}_s9userinfo`) || "{}");
    const searchData = JSON.parse(localStorage.getItem(`${restaurantID}_searchParams`) || "{}");

    const userKey = `${(user?.phone)?.replace(/\D/g, "")}`;


    const updateItemFeedback = (itemName, newData) => {
        const updated = {
            ...itemFeedback,
            [itemName]: {
                ...(itemFeedback[itemName] || {}),
                ...newData,
                Name: itemName,
                name: user?.name || "",
                phone: user?.phone || "",
                searchParams: searchData,
                updatedAt: new Date().toISOString(),
                unix: Date.now()
            }
        };

        setItemFeedback(updated);
        localStorage.setItem(`${restaurantID}_itemFeedback`, JSON.stringify(updated));
    };

    const handleFilterClick = (filterObj) => {
        const key = filterObj.filter;

        // If something is already selected → unselect directly
        if (Dietary[key]) {
            const newState = { ...Dietary };
            delete newState[key];
            setDietary(newState);
            return;
        }

        // If only 1 option → auto-select it
        if (filterObj.subOptions.length === 1) {
            setDietary({
                ...Dietary,
                [key]: filterObj.subOptions[0],
            });
            return;
        }

    };

    useEffect(() => {
        const fetchFavourites = async () => {
            if (phoneNumber) {
                try {
                    const phoneKey = phoneNumber.replace("+", "");
                    const favsSnapshot = await database
                        .ref(`Users/${phoneKey}/${restaurantID}/Favourites`)
                        .once("value");
                    const favs = favsSnapshot.val() || [];
                    setFavourits(favs);
                } catch (error) {
                    console.error("Error fetching favourites:", error);
                    setFavourits([]);
                }
            } else {
                setFavourits([]);
            }
        };
        fetchFavourites();
    }, [phoneNumber, restaurantID]);

    const groupByNameWithVariants = (items) => {
        const grouped = {};

        items.forEach((item) => {
            const name = item.Name;
            const variant =
                item.Variant?.replace(item.Name, "")
                    .replace("(", "")
                    .replace(")", "")
                    .trim() || "";
            if (!grouped[name]) {
                grouped[name] = {
                    ...item,
                    Price: {},
                };
            }

            if (item.Price !== 0 && item.Visible === true && item.Available === true) {
                grouped[name].Price[
                    `${variant && variant !== ""
                        ? variant
                        : item.Variation !== ""
                            ? item.Variation
                            : item.Name
                    }`
                ] = item.Price;
            }
        });

        return Object.values(grouped).sort((a, b) => a.Rank - b.Rank);
    };

    const groupedAddOns = AddOns && Object.values(AddOns?.filter((curr) => curr?.Group && curr?.DisplayName && curr?.ItemsName)?.reduce((acc, curr) => {
        const key = curr.Group;
        if (!acc[key]) {
            acc[key] = {
                group: curr.Group,
                displayName: curr.DisplayName,
                groupMaxLimit: parseInt(curr.MaxGroupAddonLimit) || 1,
                groupMinLimit: parseInt(curr.MinGroupAddonLimit) || 0,
                items: [],
                AddOnGroupid: curr.AddOnGroupid,
            };
        }

        const currentMaxLimit = parseInt(curr.MaxGroupAddonLimit) || 1;
        const currentMinLimit = parseInt(curr.MinGroupAddonLimit) || 0;
        acc[key].groupMaxLimit = Math.max(
            acc[key].groupMaxLimit,
            currentMaxLimit
        );
        acc[key].groupMinLimit = Math.min(
            acc[key].groupMinLimit,
            currentMinLimit
        );

        acc[key].items.push({
            name: curr.ItemsName,
            minLimit: curr?.MinItemAddonLimit || 0,
            maxLimit: curr?.MaxItemAddonLimit || 1,
            groupMaxLimit: Math.max(acc[key].groupMaxLimit, currentMaxLimit),
            groupMinLimit: Math.min(acc[key].groupMinLimit, currentMinLimit),
            price: parseFloat(curr.Price) || 0,
            AddOnItemid: curr.AddOnItemid,
        });
        return acc;
    }, {})
    );

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        setSelectedAddOns({});
    };

    const handleAddOnChange = (groupKey, itemName, action) => {
        const group = groupedAddOns.find((g) => g.group === groupKey);
        if (!group) return;

        const currentGroup = selectedAddOns[groupKey] || {};
        const item = group.items.find((i) => i.name === itemName);
        if (!item) return;

        const currentQty = currentGroup[itemName] || 0;

        // --- 1️⃣ Handle Item Level Constraints ---
        if (action === "increase") {
            const total = Object.values(currentGroup).reduce((a, b) => a + b, 0);

            if (currentQty >= item.maxLimit) return; // item max
            if (total >= group.groupMaxLimit) return; // group max

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: {
                    ...currentGroup,
                    [itemName]: currentQty + 1,
                },
            });
        }

        if (action === "decrease") {
            if (currentQty <= item.minLimit) return; // Can't go below item min
            const newQty = currentQty - 1;

            const updated = { ...currentGroup };
            if (newQty === 0) delete updated[itemName];
            else updated[itemName] = newQty;

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: updated,
            });
        }

        // --- 2️⃣ Checkbox Mode (MaxItemLimit = 1) ---
        if (action === "toggle") {
            const isSelected = currentQty > 0;
            const total = Object.values(currentGroup).reduce((a, b) => a + b, 0);

            if (isSelected) {
                // unselect – but not below min group rule
                if (total <= group.groupMinLimit && total !== group.groupMaxLimit)
                    return;

                return setSelectedAddOns({
                    ...selectedAddOns,
                    [groupKey]: {
                        ...currentGroup,
                        [itemName]: 0,
                    },
                });
            }

            // trying to check an item
            if (total >= group.groupMaxLimit) return;

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: {
                    ...currentGroup,
                    [itemName]: 1,
                },
            });
        }
    };

    const validateAddOnsForSelectedVariation = ({
        selectedValue,
        Items,
        groupedAddOns,
        selectedAddOns,
    }) => {
        const errors = [];

        // ✅ Find actual selected item / variation
        const selectedItem =
            Items.find((i) => i.Variant === selectedValue) ||
            Items.find((i) => i.Name === selectedValue);

        if (!selectedItem) {
            return { isValid: true, errors: [] };
        }

        // ✅ Add-on groups applicable to this variation
        const applicableGroups = Array.isArray(selectedItem["Add-Ons"])
            ? selectedItem["Add-Ons"]
            : [];

        // ✅ No add-ons applicable → valid
        if (applicableGroups.length === 0) {
            return { isValid: true, errors: [] };
        }

        groupedAddOns
            .filter((group) => applicableGroups.includes(group.group))
            .forEach((group) => {
                const selections = selectedAddOns[group.group] || {};

                // ✅ Total quantity in group
                const totalQty = Object.values(selections).reduce(
                    (sum, qty) => sum + (qty || 0),
                    0
                );

                // ✅ Group min
                if (group.groupMinLimit > 0 && totalQty < group.groupMinLimit) {
                    errors.push(
                        `Select at least ${group.groupMinLimit} item(s) in "${group.displayName}"`
                    );
                }

                // ✅ Group max
                if (group.groupMaxLimit > 0 && totalQty > group.groupMaxLimit) {
                    errors.push(
                        `You can select only ${group.groupMaxLimit} item(s) in "${group.displayName}"`
                    );
                }

                // ✅ Item-level rules
                group.items.forEach((item) => {
                    const qty = selections[item.name] || 0;

                    if (item.minLimit > 0 && qty < item.minLimit) {
                        errors.push(`"${item.name}" requires at least ${item.minLimit}`);
                    }

                    if (item.maxLimit > 0 && qty > item.maxLimit) {
                        errors.push(`"${item.name}" allows maximum ${item.maxLimit}`);
                    }
                });
            });

        return {
            isValid: errors.length === 0,
            errors,
        };
    };

    const AddToCart = async () => {
        if (loading) return;

        if (!phoneNumber) {
            alert("Login to place order.");
            window.location.reload();
            return;
        }

        if (selectedValue === "") {
            alert("Select a product variant to continue.");
            return;
        }

        if (count <= 0) {
            alert(
                "Oops! Can't proceed with zero quantity. Please choose how many you'd like to add."
            );
            return;
        }

        const { isValid, errors } = validateAddOnsForSelectedVariation({
            selectedValue,
            Items,
            groupedAddOns,
            selectedAddOns,
        });

        if (!isValid) {
            alert(errors.join("\n"));
            return;
        }

        let theItem = menuObj.find(
            (item) =>
                item.Variant === selectedValue ||
                (item.Name === selectedValue && !item.Variant)
        );

        const addOnsItemDetails = groupedAddOns.flatMap((group) => {
            const selections = selectedAddOns[group.group] || {};
            return group.items
                .filter((item) => selections[item.name] > 0)
                .map((item) => ({
                    Name: item.name,
                    Price: item.price,
                    Qty: selections[item.name],
                    Group: group.group,
                    GroupDisplayName: group.displayName,
                    Limit: group.groupMaxLimit,
                    AddOnGroupid: group.AddOnGroupid,
                    AddOnItemid: item.AddOnItemid,
                }));
        });

        let Amount = theItem.Price * count;

        addOnsItemDetails.forEach((addOn) => {
            Amount += addOn.Price * addOn.Qty * count;
        });

        const cartItem = {
            ...theItem,
            Qty: count,
            SelectedAddOns: addOnsItemDetails,
            AdditionalNotes,
            Amount,
        };

        setCart((prev) => {
            const updated = [...prev, cartItem];
            localStorage.setItem(`${restaurantID}_Cart`, JSON.stringify(updated));
            console.log("Cart updated:", updated);
            return updated;
        });

        // enable vibration support
        navigator.vibrate =
            navigator.vibrate ||
            navigator.webkitVibrate ||
            navigator.mozVibrate ||
            navigator.msVibrate;

        if (navigator.vibrate) {
            // vibration API supported
            navigator.vibrate(1000);
        }

        navigator.vibrate?.(150);
        audio?.play();

        audio.play();

        setSelectedValue("");
        setSelectedAddOns({});
        setAdditionalNotes(null);
        setCount(0);
        await window.gtag("event", `Added_To_Cart`, (prev) => {
            const updated = [...prev, cartItem];
            localStorage.setItem(`${restaurantID}_Cart`, JSON.stringify(updated));
            return updated;
        });
        alert("Item added to Cart successfully!");
        // window.location.reload();
    };

    // Handle auto-expansion of item from query parameter
    useEffect(() => {
        const expandItemParam = searchParams.get('expandItem');
        if (expandItemParam && Data) {
            const itemToExpand = Data.find(item => item.Name === decodeURIComponent(expandItemParam));
            if (itemToExpand) {
                setExpandedItem(itemToExpand);
                setExpandedDetails(true);
                // Scroll to the item after a small delay to ensure it's rendered
                setTimeout(() => {
                    const itemElement = document.getElementById(itemToExpand.Name);
                    if (itemElement) {
                        itemElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            }
        }
    }, [searchParams, Data]);

    useEffect(() => {
        try {
            const getData = async () => {
                if (!menuObj) return;

                const groupedData = groupByNameWithVariants(menuObj);
                setData(groupedData);
            };
            getData();
        }
        catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
        }
    }, [menuObj]);

    const BackButton = (e) => {
        const timestamp = new Date();
        window.gtag("event", `${e}_Click`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            click: e,
        });
        if (window.history.length >= 1) {
            // There's something in the history stack to go back to
            window.history.back();
        } else {
            // No history, redirect to fallback
            window.location.href = "/"; // or "/dashboard", or any fallback route
        }
    };

    const openDetailedCard = (item) => {
        const timestamp = new Date();
        window.gtag("event", `${item.Name}_Card_Opened`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            itemName: item.Name,
            itemDetails: item,
        });
        setExpandedDetails(true);

        if (item?.Name === expandedItem?.Name) {
            setExpandedItem(null);
            return;
        }

        setCount(1);
        setSelectedAddOns({});
        setAdditionalNotes(null);

        const relevantItems = menuObj?.filter(
            (menuObjItems) =>
                menuObjItems?.Name === item?.Name &&
                menuObjItems.Price !== 0 &&
                menuObjItems.Price !== null &&
                menuObjItems.Price !== "" &&
                menuObjItems.Visible === true &&
                menuObjItems.Visible !== false
        );

        if (relevantItems?.length === 1) {
            const option = relevantItems[0];
            setSelectedValue(option.Variant ? option.Variant : option.Name);
        } else {
            setSelectedValue("");
        }

        setExpandedItem(item);
    };

    const handleSubmit = async (itemName) => {
        const feedbackData = itemFeedback[itemName];

        if (!feedbackData || (!feedbackData.Score && !feedbackData.Comment)) {
            alert("Please provide feedback before submitting.");
            return;
        }

        const unix = Date.now();

        const tableId = localStorage.getItem(`${restaurantID}_S9Table`) || "";

        const finalPayload = {
            ...feedbackData,
            Name: itemName,
            restaurantID,
            timestamp: new Date().toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false }).replace("T", " "),
            unix: unix,
            table: tableId,
        };

        try {
            if (!userKey) {
                const name = window.prompt("Please enter your name:");
                if (!name || name.trim().length < 2) {
                    alert("Name must be at least 2 characters.");
                    return;
                }

                const phone = window.prompt("Please enter your 10-digit phone number:");
                const phoneRegex = /^[6-9]\d{9}$/;
                if (!phoneRegex.test(phone)) {
                    alert("Invalid phone number format.");
                    return;
                }

                localStorage.setItem(
                    `${restaurantID}_s9userinfo`,
                    JSON.stringify({ name: name.trim(), phone })
                );
                return;
            }

            const safeItemName = itemName.replace(/[^a-zA-Z0-9 ]/g, "_");

            // 🔥 KEY = user + item (UPDATE instead of duplicate)
            await database
                .ref(`s9itemFeedback/${restaurantID}/${userKey}/${safeItemName}`)
                .update(finalPayload);

            window.gtag("event", `${itemName}_Feedback_Submitted`, {
                feedback: finalPayload,
                From: "MenuCard",
                ...searchData
            });

            alert("Feedback submitted successfully!");
            setExpandedItem(null);
        } catch (err) {
            console.error(err);
            alert("Something went wrong!");
        }
    };
    const redirectTrigger = (e) => {
        const timestamp = new Date();
        // Track successful login event
        window.gtag("event", `${e}_Click`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            click: e,
        });
        window.location.href = e;
    };

    const handleShare = async ({ title, desc, img }) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `${title}\n` || "R\n",
                    text: `\n${desc}\n` || "\nCheck out this amazing dish!\n",
                    url:
                        `${window.location.origin}/Product/Name/${encodeURIComponent(
                            title
                        )}` || "https://samudaya.ettarracoffee.com",
                });
                const timestamp = new Date();
                window.gtag("event", "product_share", {
                    timestamp: timestamp
                        .toLocaleString("sv-SE", {
                            timeZone: "Asia/Kolkata",
                            hour12: false,
                        })
                        .replace("T", " "),
                    event_category: "engagement",
                    event_label: title,
                    description: desc,
                    link: `${window.location.origin}/Product/Name/${encodeURIComponent(
                        title
                    )}`,
                });
                console.log("Shared successfully");
            } catch (err) {
                console.error("Error sharing:", err);
            }
        } else {
            alert("Sharing not supported on this browser");
        }
    };

    return (
        <>
            {["Baked Buns", "Cold Sandwiches", "Juices"].map((section) => {

                const sectionItems = Data?.filter(
                    (item) => item.SubCategory === section && item?.Visible
                );

                if (!sectionItems || sectionItems.length === 0) return null;

                return openedSection === section ? (
                    <div key={section} style={{ transition: 'height 1s ease-in-out', }}>
                        <hr style={{ margin: '25px 10px 0px 10px' }} />
                        <div
                            key={section}
                            className="loading"
                            onClick={() => setOpenedSection(null)}
                            style={{ fontSize: '18px', fontWeight: '700', color: '#001E3A', width: '90vw', cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '5px', borderRadius: '25px', padding: '20px 20px 20px 15px', marginTop: '15px', backgroundColor: '#FFFFFF' }}
                        >
                            {section}&nbsp;<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#001E3A"><path d="m256-424-56-56 280-280 280 280-56 56-224-223-224 223Z" /></svg>
                        </div>

                        {sectionItems.map((item) => (
                            (item && item.Visible && (
                                <div key={`${item.Name}_${item.Variation}`} className='mb-2' >
                                    {item && item.Visible && (
                                        <div
                                            key={`${item.Variant}_${item.Description}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openDetailedCard(item);
                                            }}
                                        >
                                            <div className="item-card" id={`${item.Name}`}>
                                                {" "}
                                                {/*onClick={() => openDetailedCard(item)}>*/}
                                                {item.Available === false ? (
                                                    <div
                                                        className="Unavailable"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        Unavailable
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="item-card-info">
                                                    <div className="item-labels-icons" style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginBottom: '5px' }}>
                                                        {item['IsNew'] && <span className='item-top-labels-text'>New</span>}
                                                        {item['IsPopular'] && <span className='item-top-labels-text'>Popular</span>}
                                                        {item['IsBestSeller'] && <span className='item-top-labels-text'>Best Seller</span>}
                                                        {item['IsRecommended'] && <span className='item-top-labels-text'>Recommended</span>}
                                                    </div>
                                                    <div className="item-card-name">{item.Name}</div>
                                                    <div className="item-labels-icons">
                                                        {(item?.Dietary === "Veg" && <span className='css-label-icon-veg'>V</span>)}
                                                        {(item?.Dietary === "Non-Veg" && <span className='css-label-icon-nonveg'>NV</span>)}
                                                        {(item?.Dietary === "Egg" && <span className='css-label-icon-egg'>E</span>)}
                                                        {LabelsData?.filter(LabelsDataItem =>
                                                            item?.Labels.includes(LabelsDataItem?.['Label'])
                                                        ).map(filteredLabel => (
                                                            <img
                                                                key={filteredLabel?.Label || Date.now()}
                                                                src={filteredLabel?.URL}
                                                                alt={filteredLabel?.Label || 'label-icon'}
                                                                className="item-labels-icon"
                                                            />
                                                        ))}
                                                        {item?.['Custom Text Label'] && item?.['Custom Text Label'][0] && item['Custom Text Label'].map((labeltext) => (<span key={labeltext} className='item-labels-text-custom'>{labeltext}</span>))}
                                                        {item?.['KiloCalories'] && <><div style={{ height: '20px', fontSize: '11px', lineHeight: '20px', fontWeight: 600, textAnchor: 'middle', paddingLeft: '7px', color: '#FF0000' }}><img src={cals} alt='cals' className="item-labels-icon" />{item?.['KiloCalories']}</div></>}
                                                    </div>
                                                    <div className="item-card-desc">
                                                        {item.Description}
                                                    </div>
                                                    {(item.Name !== expandedItem?.Name) && (Object.keys(item.Price).length === 1) && (groupedAddOns?.filter((groupedAddOn) => menuObj?.[(menuObj?.findIndex((Item) => (Item?.Name === expandedItem?.Name)))]?.['Add-Ons'].includes(groupedAddOn?.group) ||
                                                        menuObj[(menuObj?.findIndex((Item) => (Item?.Variant === expandedItem?.Name)))]?.['Add-Ons'].includes(groupedAddOn?.group))?.length === 0) ? <div style={{ fontSize: '14px', fontWeight: 700, lineHeight: '16px', textAnchor: 'middle', color: '#333', textAlign: 'left', margin: '3px 0px' }}>{Object.keys(item.Price)[0]}{Object.keys(item.Price)[0] && ": "}{Object.values(item.Price)[0]}</div> : <>
                                                        <div className='view-price'><i>{item.Name !== expandedItem?.Name ? 'View' : 'Hide'} Feedback Form{Object.keys(item.Price).length > 1 ? 's' : ''}</i>
                                                        </div>
                                                    </>}
                                                </div>
                                                <>
                                                    {item.Name !== expandedItem?.Name ? (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "130px",
                                                                translateY: "-50%",
                                                                left: "calc(92vw - 32.5px - 72px)",
                                                                width: "50px",
                                                                height: "27px",
                                                                background: "#FFFFFF",
                                                                borderRadius: "70px",
                                                                boxShadow: "0px 0px 7px #4F3C2B99",
                                                                textAlign: "center",
                                                                color: "#001E3A",
                                                                rotate: "180deg",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openDetailedCard(item);
                                                            }}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                height="27px"
                                                                viewBox="0 -960 960 960"
                                                                width="30px"
                                                                fill="#001E3A"
                                                            >
                                                                <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "130px",
                                                                translateY: "-50%",
                                                                left: "calc(92vw - 25px - 72px)",
                                                                width: "35px",
                                                                height: "27px",
                                                                background: "#FFFFFF",
                                                                borderRadius: "70px",
                                                                boxShadow: "0px 0px 7px #4F3C2B99",
                                                                textAlign: "center",
                                                                color: "#001E3A",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setExpandedItem(null);
                                                            }}
                                                        >
                                                            <svg
                                                                style={{ rotate: "360deg" }}
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                height="27px"
                                                                viewBox="0 -960 960 960"
                                                                width="27px"
                                                                fill="#001E3A"
                                                            >
                                                                <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                            </svg>
                                                        </div>
                                                    )}
                                                </>
                                                {item["Image"] &&
                                                    item["Image"] !== "" &&
                                                    item["Image"] !== null &&
                                                    item["Image"] !== "nan" ? (
                                                    <div className="item-card-img">
                                                        <img src={item["Image"]} alt={item.Name} />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="item-card-img"
                                                        style={{ boxShadow: "none" }}
                                                    ></div>
                                                )}
                                                {item?.["ImagePreview"] && item?.["ImagePreview"] != "" && (
                                                    <div style={{ position: "absolute", top: 15, right: 15, width: "48px", height: "24px", borderRadius: "25px", boxShadow: "inset 1px 1px 5px #00000020, 1px 1px 5px #00000055", backgroundColor: item?.["ImagePreview"] ? item?.["ImagePreview"] : "#FFFFFF" }} className="item-card-img-preview"></div>
                                                )}
                                                {item["Image"] && (
                                                    <button
                                                        style={{
                                                            position: "absolute",
                                                            top: "20px",
                                                            right: "115px",
                                                            borderRadius: "15px",
                                                            border: "0px",
                                                            width: "24px",
                                                            height: "24px",
                                                            padding: "0px",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            display: "flex",
                                                            backgroundColor: "#00000055",
                                                            boxShadow: "inset 0px 0px 10px #0000035",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShare({
                                                                title: item.Name,
                                                                desc: item.Description,
                                                                img: item["Image"],
                                                            });
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="14px"
                                                            viewBox="0 -960 960 960"
                                                            width="14px"
                                                            fill="#FFFFFF"
                                                        >
                                                            <path
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M251.78-32.39q-42.24 0-71.62-29.38-29.38-29.38-29.38-71.62v-393.56q0-42.25 29.38-71.63 29.38-29.38 71.62-29.38H354.5v101.01H251.78v393.56h456.44v-393.56H605.5v-101.01h102.72q42.24 0 71.62 29.38 29.38 29.38 29.38 71.63v393.56q0 42.24-29.38 71.62-29.38 29.38-71.62 29.38H251.78ZM429.5-307.72v-426.21l-65 65-70.59-71.03L480-926.61l186.09 186.65-70.59 71.03-65-65v426.21h-101Z"
                                                            />
                                                        </svg>
                                                    </button>
                                                )}

                                                {
                                                    item.Name === expandedItem?.Name ? (
                                                        <>
                                                            <div className={`item-card-expanded-tabs`}>

                                                                <div
                                                                    className={`item-card-expanded-tab item-card-expanded-tab-active`}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setExpandedDetails(false);
                                                                    }}
                                                                >
                                                                    Share Feedback
                                                                </div>
                                                            </div>
                                                            {expandedDetails && (<>
                                                                <div className="item-card-expanded">
                                                                    <label className="feedback-form-question">
                                                                        How much do you like this item?
                                                                    </label>
                                                                    <div
                                                                        className="feedback-form-checkbox-group"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {[1, 2, 3, 4, 5].map((value) => (
                                                                            <label key={value}>
                                                                                <input
                                                                                    className="checkbox-label"
                                                                                    type="radio"
                                                                                    name={`question${expandedItem.Name}`}
                                                                                    value={value}
                                                                                    checked={
                                                                                        itemFeedback[expandedItem.Name]
                                                                                            ?.Score === value
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        e.stopPropagation();
                                                                                        updateItemFeedback(expandedItem.Name, {
                                                                                            Score: parseInt(e.target.value)
                                                                                        });
                                                                                    }}
                                                                                />
                                                                                <span>{value}</span>
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                    <label className="feedback-form-question">
                                                                        Additional Feedback Comments:
                                                                    </label>
                                                                    <textarea
                                                                        placeholder="Your answer"
                                                                        className="feedback-form-textarea"
                                                                        value={
                                                                            itemFeedback[expandedItem.Name]
                                                                                ?.Comment || ""
                                                                        }
                                                                        onClick={(e) => { e.stopPropagation(); }}
                                                                        onChange={(e) => {
                                                                            e.stopPropagation();
                                                                            updateItemFeedback(expandedItem.Name, {
                                                                                Comment: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                    <button
                                                                        className="feedback-form-submit"
                                                                        onClick={() =>
                                                                            handleSubmit(expandedItem.Name)
                                                                        }
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                </div>
                                                                <br />
                                                                <div
                                                                    style={{
                                                                        fontSize: "20px",
                                                                        lineHeight: "25px",
                                                                        fontWeight: 700,
                                                                        width: "70vw",
                                                                        textAlign: "center",
                                                                        letterSpacing: "-5px",
                                                                        margin: "5px 5vw 0px 5vw",
                                                                        color: "#001E3A",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setExpandedItem(null);
                                                                    }}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        height="30px"
                                                                        viewBox="0 -960 960 960"
                                                                        width="30px"
                                                                        fill="#001E3A"
                                                                    >
                                                                        <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                                    </svg>
                                                                </div>
                                                            </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))))}
                    </div>
                ) : (
                    <div
                        key={section}
                        className="loading"
                        onClick={() => setOpenedSection(section)}
                        style={{ fontSize: '24px', fontWeight: 'bold', color: '#001E3A', width: '94vw', cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '5px', borderRadius: '25px', padding: '25px 25px 25px 15px', marginTop: '25px', backgroundColor: '#FFFFFF', boxShadow: '2px 1px 10px #24242445' }}
                    >
                        {section}&nbsp;<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#001E3A"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" /></svg>
                    </div>
                );
            })}
        </>
    );
};

export default MenuDrops;
